<template>
  <div
    class="main__div px-3"
    :class="$vuetify.breakpoint.xsOnly ? 'px-5' : ''"
    style="background-color: #f2f8ff !important"
  >
    <v-skeleton-loader
      height="300"
      v-if="profileLoading"
      class="mt-3"
      type="card-avatar, article, actions, card-avatar, sentences"
    ></v-skeleton-loader>
    <!-- <Card
      @follow="getCount"
      v-if="!profileLoading"
      :profile_object="profile_object"
      :is_user_profile="true"
    /> -->

    <user-profile-card
      @follow="getCount"
      v-if="!profileLoading"
      :profile_object="profile_object"
      :is_user_profile="true"
    ></user-profile-card>
    <!-- <ProfileCard
      @follow="getCount"
      v-if="!profileLoading"
      :profile_object="profile_object"
      :is_user_profile="true"
    >
    </ProfileCard> -->

    <trade-detail-form
      v-if="trade_detail_form.flag"
      @reload-profile="$emit('reloadProfile')"
      :trade_detail_form="trade_detail_form"
      @reload-trades="$emit('reloadTrades')"
      @deleteTrades="getTradeList(0)"
      @reload-trade-data="getTradeList(0)"
      @reload-trade-data-comment="getTradeAfterComment"
    />
    <reviewand-post-trade
      @trade-edit="tradeEdit"
      @reloadTrades="getTradeList(0)"
      @share-trade="shareTrade"
      :trade_review_data="trade_review_data"
      v-if="trade_review_data.flag"
    />
    <!-- <TradeForm
      @trade-review="reviewTrade"
      @reload-trades="getTradeList(0)"
      :trade_form_data="trade_form_data"
      v-if="trade_form_data.flag"
    /> -->

    <profile-page-my-group-row
      :profile_object="profile_object"
    ></profile-page-my-group-row>
    <!-- <DisplayVideosComponent></DisplayVideosComponent> -->
    <div :class="$vuetify.breakpoint.smAndUp ? 'px-5' : ''">
      <profile-video-listing :user_id="user"></profile-video-listing>
    </div>
    <!-- {{ getVideoNumber }} -->
    <div class="trades_list__div" id="tradeslist">
      <div>
        <!-- <profile-trade-detail
          :user_id="user"
          @getProfileDetails="getProfileDetails"
        ></profile-trade-detail> -->
        <profile-trades
          :user_id="user"
          @getProfileDetails="getProfileDetails"
        ></profile-trades>
      </div>
      <v-row>
        <v-col cols="12">
          <v-fab-transition class="floatingIcon">
            <v-btn
              color="#2D8CFF"
              dark
              class="mb-15 floatingIcon text-capitalize elevation-4"
              bottom
              rounded
              inner-height="44"
              right
              fixed
              style="z-index: 4"
              @click="addTrade()"
            >
              <v-icon small>mdi-plus</v-icon>
              <span style="font-weight: 800; letter-spacing: 0px"
                >Add Trade</span
              >
            </v-btn>
          </v-fab-transition>
        </v-col>
      </v-row>
    </div>
    <!-- <TradeDetailDialog> </TradeDetailDialog> -->
  </div>
</template>

<script>
// import PlaylistVideosListing from "@/components/Profile/VideoCourse/VideoPlayList/DetailedPlaylist/PlaylistVideosListing.vue";
// import DisplayVideosComponent from "@/components/Profile/VideoCourse/DisplayVideosComponent.vue";
// import ProfileCard from "@/components/Profile/ProfileCard.vue";

import Axios from "@/api/BaseAxios.js";
// import TradeDetailForm from "@/components/Trade/TradeDetailForm.vue";
// import TradeDetailDialog from "@/components/Trade/TradeDetailDialog.vue";
import { isAuthenticated } from "../../common/commonFunctions";
import commonFunctions from "../../common/commonFunctions";
import ReviewandPostTrade from "../../components/Trade/ReviewandPostTrade.vue";
import ProfilePageMyGroupRow from "@/components/ProfilePageMyGroupRow.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProfilePage",
  components: {
    // DisplayVideosComponent,

    // TradeDetailForm,
    ReviewandPostTrade,
    // ProfileCard,
    ProfilePageMyGroupRow,
    // TradeDetailDialog,
    // ProfileTradeDetail: () =>
    //   import("@/components/Profile/ProfileTradeDetails/ProfileTradeDetails"),
    ProfileVideoListing: () =>
      import("../../components/VideoCourse/ProfileListing/ProfileListing.vue"),
    ProfileTrades: () =>
      import("@/components/Profile/ProfileTradeDetails/ProfileTrades"),
    UserProfileCard: () => import("@/components/Profile/UserProfileCard.vue"),
    // TradeDetailDialog: () => import("@/components/Trade/TradeDetailDialog.vue"),
  },
  metaInfo: {
    title: "My Profile",
  },
  data: () => ({
    menu: false,
    user: null,
    dates: [],
    showFill: false,
    profile_object: {},
    trades: [],
    hidefilters: true,
    profileLoading: false,
    tradesLoading: false,
    page: 1,
    isFiltering: false,
    pageNum: 1,
    statusItems: [
      { name: "Live", value: "Active" },
      { name: "Upcoming", value: "Inactive" },
      { name: "Closed", value: "Closed" },
    ],
    buysellItems: ["Buy", "Sell"],

    durationItems: [
      { name: "Intra-day", value: "Intra-day-BTST (1~2 days)" },
      { name: "Short-term", value: "Short term (1~2 weeks)" },
      { name: "Intermediate", value: "Intermediate (2~6 weeks)" },
      { name: "Long-term", value: "Long term (>6 weeks)" },
    ],
    status: [],
    buy_sell: [],
    sorts: null,
    duration: [],
    trade_form_data: {
      flag: false,
      id: null,
      trade_data: {},
      trade_edit: false,
    },
    trade_detail_form: {
      flag: false,
      id: null,
    },
    hide: true,
    trade_review_data: {
      flag: false,
      trade_data: {},
    },
    selectedTab: 0,
    tradeCount: { posted: 0, followed: 0, today: 0, past_week: 0, other: 0 },
    todaysTrade: [],
    pastWeekTrade: [],
    otherTrade: [],
    expansion: [
      { title: `Today’s Trades`, flag: true, count: 0, items: [] },
      {
        title: `Previous Week’s Trades`,
        flag: true,
        count: 0,
        items: [],
      },
      {
        title: `Other Previous Trades`,
        flag: true,
        count: 0,
        items: [],
      },
    ],
    global_count: {
      allPostedCount: 0,
      followedCount: 0,
      orderCount: 0,
      portfolioCount: 0,
      historyCount: 0,
    },
  }),
  watch: {
    dates(value) {
      // filterTrades
      if (value.length < 2) {
        if (value.length === 1) {
          // this.dates[0] = new Date(this.dates[0])
        }
        console.log(value);
        this.filterTrades();
      }
    },
  },
  computed: {
    ...mapGetters({
      showTradeDialog: "tradeCardDialog/getShow",
    }),

    dateFormattedText: {
      get() {
        if (this.dates.length) {
          if (this.dates.length == 1) {
            return this.moment(this.dates[0]).format("MMM-DD");
          } else {
            return `${this.moment(this.dates[0]).format(
              "MMM-DD"
            )},${this.moment(this.dates[1]).format("MMM-DD")}`;
          }
        } else {
          return "";
        }
      },
    },
    is_calender_data: {
      get() {
        if (
          !this.expansion[0].items.length &&
          !this.expansion[1].items.length &&
          !this.expansion[2].items.length
        ) {
          return false;
        } else {
          return true;
        }
      },
    },
    is_filter: {
      get() {
        if (
          this.status.length ||
          this.buy_sell.length ||
          this.duration.length ||
          this.dates.length
        ) {
          return true;
        } else if (
          !this.expansion[0].items.length &&
          !this.expansion[1].items.length &&
          !this.expansion[2].items.length
        ) {
          return true;
        } else {
          return false;
        }
      },
      set() {
        return (this.status = []), (this.buy_sell = []), (this.duration = []);
      },
    },
  },

  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
      toggleTradeDetailModal: "tradeCardDialog/toggleModal",
    }),
    getOpen(flag) {
      return !flag;
    },
    getProfileDetails(state) {
      this.profileLoading = state;
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.profile_object = res.data.result;

        // setTimeout(() => {
        this.profileLoading = false;
        // }, 1000);
      };
      const errorHandler = (err) => {
        console.log(err);
        this.profileLoading = false;
      };
      let formData = {};
      if (commonFunctions.getUserId()) {
        formData["request_user"] = commonFunctions.getUserId();
      }
      Axios.request_GET(
        `api/profile-details/${user_id}`,
        formData,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    viewTrade(id) {
      this.trade_detail_form.flag = true;
      this.trade_detail_form.id = id;
    },
    reviewTrade(data) {
      this.trade_review_data.trade_data = data;
      this.trade_review_data.flag = true;
    },
    tradeEdit(data) {
      this.trade_form_data.trade_data = data;
      this.trade_form_data.trade_edit = true;
      this.trade_form_data.flag = true;
    },
    shareTrade(data) {
      navigator
        .share(
          {
            title: "Covesto",
            text: `Hello, ${data.posted_by_name} has shared a trade recommendation on Covesto.${data.trade_type} ${data.security_name}
            To know more details and get live updates, follow the trade at `,
            url: `https://covesto.in/trade/${data.id}/${data.security.name}`,
          },
          {
            skype: false,
            pinterest: false,
            print: false,
            sms: false,
          }
        )
        .then(() => console.log("Yay, you shared it :)"))
        .catch((error) =>
          console.log("Oh noh! You couldn't share it! :'(\n", error)
        );
      this.getTradeList(0);
    },

    addTrade() {
      this.$logEvent("add_trade_profile_page");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_trade_profile_page");
      }
      this.trade_form_data.flag = true;
      this.toggleAddTradeModal({ show: true, type: "add" });
    },

    filterTrades(item) {
      this.hidefilters = false;
      this.tradesLoading = true;
      this.page = 1;
      this.getCount();
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        if (item == "append") {
          res.data.results.forEach((i) => {
            this.trades.push(i);
          });
          this.numPages = res.data.num;
        } else {
          this.trade = [];
          this.trades = res.data;
          this.numPages = res.data.num;
          setTimeout(() => {
            this.tradesLoading = false;
          }, 1000);
        }
        // this.tradesLoading = false;
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      // if(this.dates.length===1){
      //   this.dates = [new Date(this.dates[0])]
      // }
      Axios.request_GET(
        `api/trade/filter-trades/${this.selectedTab}/${user_id}/${this.page}/${
          !this.status.length ? null : this.status
        }/${!this.buy_sell.length ? null : this.buy_sell}/${
          !this.duration.length ? null : this.duration
        }/${this.dates.length ? this.dates : null}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    getTrades(item) {
      this.status = [];
      this.buy_sell = [];
      this.duration = [];
      this.dates = [];
      this.selectedTab = item;
      this.page = 1;
      this.hide = true;
      this.pageNum = 1;
      this.getTradeList();
      this.getList();
      this.isFiltering = false;
      this.tradesLoading = true;
    },
    getTradeAfterComment() {
      this.page = 1;
      this.getTradeList(0);
      this.getList();
    },
    getList() {
      this.getTradeList(0);
    },
    async getTradeList(item) {
      await this.getCount();
      this.isFiltering = false;
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        if (item == "append") {
          res.data.other.forEach((i) => {
            this.expansion[2].items.push(i);
          });
          this.numPages = res.data.num;
        } else {
          this.trades = [];
          this.trades = res.data.result;
          this.numPages = res.data.num;
          // if(this.is_filter){
          this.expansion[0].count = res.data.count.trade_today;
          this.expansion[1].count = res.data.count.trade_past_week;
          this.expansion[2].count = res.data.count.trade_other;
          this.expansion[0].items = res.data.today;
          this.expansion[1].items = res.data.past_week;
          this.expansion[2].items = res.data.other;
          // }
          setTimeout(() => {
            this.hidefilters = false;
            this.tradesLoading = false;
          }, 500);
        }
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      let formData = {};
      // formData["user_id"]=user_id
      // formData["filter_by"]= this.selectedTab==0?"posted":"followed"
      // formData["page_number"] = this.page
      // if(this.buy_sell.length){
      //   formData["buy_sell"] = JSON.stringify(this.buy_sell)
      // }
      // if(this.duration.length){
      //   formData["duration"] = JSON.stringify(this.duration)
      // }
      // if(this.status.length){
      //   formData["status"] = JSON.stringify(this.status)
      // }
      // if(this.dates.length){
      //   formData["dates"] = JSON.stringify(this.dates)
      // }
      Axios.request_GET(
        `api/trade/trade-list/${user_id}/${this.selectedTab}/${this.page}`,
        // {},
        // "api/trade/trade-list-view/",
        formData,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    getCount() {
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.tradeCount.posted = res.data.posted_count;
        this.tradeCount.followed = res.data.followed_count;
        this.global_count.allPostedCount = res.data.posted_count;
        this.global_count.followedCount = res.data.followed_count;
        this.global_count.orderCount = res.data.inactive_count;
        this.global_count.portfolioCount = res.data.active_count;
        this.global_count.historyCount = res.data.closed_count;
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      Axios.request_GET(
        `api/trade/get-trades-count/${user_id}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    onIntersect(entries, observer) {
      console.log(entries, observer);
      this.hide = true;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.page += 1;
          if (this.page <= this.numPages) {
            this.getTradeList("append");
          } else {
            this.hide = false;
          }
        }
      });
    },
  },
  beforeMount() {
    this.user = parseInt(localStorage.getItem("user_id"));
  },
  async created() {
    this.eventBus.$on("update-profile-detail", () => {
      // this.getProfileDetails(false);
      this.getTradeList(0);
    });

    // this.eventBus.$on("delete-trade", () => {
    //   console.log("call event get trade list");
    //   // this.getProfileDetails(true);
    //   this.getTradeList(0);
    // });

    this.eventBus.$on("refresh_profile_data", () => {
      // this.getProfileDetails(false);
      this.getProfileDetails(true);
      console.log("PROFILEEEEEEEEEEEEEEEEEEEEEEEE");
    });
  },
  beforeDestroy() {
    this.eventBus.$off("update-profile-detail");
    this.eventBus.$off("refresh_profile_data");
    // this.eventBus.$off("delete-trade");
  },
  mounted() {
    this.getProfileDetails(true);
    if (isAuthenticated()) {
      this.$store.state.Auth.isPrivate = true;
      this.$store.state.Auth.checkStatus = "HOME";
    }
    this.$logEvent("my_profile_view");
    if (this.$vuetify.breakpoint.xsOnly) {
      this.$logEvent("mweb_my_profile_view");
    }
    if (this.$route.query.trade_id) {
      this.toggleTradeDetailModal({
        show: true,
        id: this.$route.query.trade_id,
      });
      // this.viewTrade(this.$route.query.trade_id);
    }
  },
};
</script>

<style scoped>
@media all and (max-width: 600px) {
  .main__div {
    min-height: 100vh;
    width: 100% !important;
    overflow-x: hidden;
  }

  .trades_list__div {
    width: 100% !important;
    margin: 0px !important;
  }

  p {
    font-size: 16px !important;
    padding-top: 10px;
    font-weight: 900;
  }

  .title {
    justify-content: space-between !important;
    display: flex;
    height: 60px;
  }

  .tab,
  .trade-tabs {
    height: 60px;

    width: 100% !important;
  }

  .tab {
    letter-spacing: 0px !important;
  }

  .add-trade-button {
    display: none;
  }

  .trade-cards-container {
    padding: 0px;
    width: 100%;
    grid-template-columns: auto !important;
    overflow-x: hidden;
  }

  .trade-card {
    width: 100% !important;
    box-shadow: 0px 0.937143px 0px rgba(0, 0, 0, 0.14);
    padding: 0px !important;
    margin-right: 20px;
  }

  .floatingIcon {
    display: inline-flex !important;
  }

  .sort-and-filter {
    width: 100% !important;
    text-align: center !important;
    margin-left: 5px;
  }

  .skeleton-loader {
    width: 100% !important;
  }
}

.selectBox {
  margin: 10px 10px 0px 0px;
  height: 45px !important;
}

.sort-and-filter {
  width: 800px;
}

.floatingIcon {
  display: none;
}

.add-trade-button {
  letter-spacing: 0px;
  font-size: 16px;
}

.main__div {
  min-height: 100vh !important;
  width: 100%;
}

.trades_list__div {
  min-height: 58vh;
  margin: 20px;
  background: #f2f8ff !important;
}

.title {
  display: flex;
  justify-content: space-between;
}

p {
  font-size: 18px;
  font-weight: 800;
}

.tradeListHeading {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 27px;

  color: #333333;
}

.add-trade-button {
  text-transform: capitalize;
  color: #fff;
}

.trade-cards-container {
  display: grid;
  grid-template-columns: repeat(3, 31.2%);
  justify-content: space-between;
  grid-row-gap: 15px;
  width: 100% !important;
}

.trade-card {
  margin-top: 20px;
}

.trade-tabs {
  background: #f2f8ff !important;
  text-transform: capitalize;
  /* width: 200px !important; */
}

.tab {
  text-transform: none;
  width: 200px;
}
</style>
